import { db } from '@/shared/services/firebase'

const fetchDocumentRequests = ({ status, userId }) => new Promise((resolve, reject) => {
  let query = db.collection('documentRequests')
    .where('status', '==', status)

  if (userId) {
    query = query.where('user', '==', userId)
  }

  query.limit(999)
    .orderBy('requestedAt', 'desc')
    .get()
    .then(async snapshot => {
      const data = snapshot.docs.map(doc => {
        const item = doc.data()
        item.id = doc.id
        return item
      })
      resolve(data.filter(item => !item.isTemplate))
    })
    .catch(() => {
      reject()
    })
})

const searchUsers = ({ q, callback }) => {
  const strlength = q.length
  const strFrontCode = q.slice(0, strlength - 1)
  const strEndCode = q.slice(strlength - 1, strlength)
  const startcode = q
  const endcode = strFrontCode + String.fromCharCode(strEndCode.charCodeAt(0) + 1)
  db.collection('users')
    .where('isAdmin', '==', false)
    .where('confirmed', '==', true)
    .where('fullName', '>=', startcode)
    .where('fullName', '<=', endcode)
    .limit(6)
    .get()
    .then(async snapshot => {
      const data = snapshot.docs.map(doc => {
        const item = doc.data()
        item.id = doc.id
        return item
      })
      callback(data)
    })
}

const createOrUpdateDocumentRequest = ({ data }) => new Promise((resolve, reject) => {
  const { id, ...documentRequest } = data
  // Update
  if (id) {
    db.collection('documentRequests')
      .doc(id)
      .update(documentRequest)
      .then(() => {
        resolve()
      })
      .catch(error => {
        reject(error)
      })
  } else { // Create
    db.collection('documentRequests')
      .add(documentRequest)
      .then(() => {
        resolve()
      })
      .catch(error => {
        reject(error)
      })
  }
})

const getUser = async id => {
  const user = await db.collection('users')
    .doc(id)
    .get()
    .then(doc => ({ ...doc.data(), id }))
    .catch(() => null)
  return user
}

const deleteDocumentRequest = id => new Promise((resolve, reject) => {
  db.collection('documentRequests').doc(id).update({
    status: 'deleted',
  })
    .then(() => {
      resolve()
    })
    .catch(error => {
      reject(error)
    })
})

const fetchDocumentRequest = id => new Promise((resolve, reject) => {
  db.collection('documentRequests')
    .doc(id)
    .get()
    .then(async snapshot => {
      const data = snapshot.data()
      if (data.user) {
        data.user = await getUser(data.user)
      }
      data.comments = data.comments.sort((a, b) => b.date.toMillis() - a.date.toMillis())
      resolve({ ...data, id })
    })
    .catch(error => {
      reject(error)
    })
})

const updateUser = async ({ data }) => {
  const { id, ...newState } = data
  await db.collection('users')
    .doc(id)
    .update(newState)
}

const markAsReadUserMessages = id => new Promise((resolve, reject) => {
  db.collection('documentRequests')
    .doc(id)
    .update({
      badgeHR: 0,
    }).then(() => {
      resolve()
    })
    .catch(error => {
      reject(error)
    })
})

const searchDocumentRequestTemplates = ({ q, callback }) => {
  const strlength = q.length
  const strFrontCode = q.slice(0, strlength - 1)
  const strEndCode = q.slice(strlength - 1, strlength)
  const startcode = q
  const endcode = strFrontCode + String.fromCharCode(strEndCode.charCodeAt(0) + 1)

  db.collection('documentRequests')
    .where('isTemplate', '==', true)
    .where('name', '>=', startcode)
    .where('name', '<=', endcode)
    .limit(999)
    .get()
    .then(async snapshot => {
      const data = snapshot.docs.map(doc => {
        const item = doc.data()
        item.id = doc.id
        return item
      })
      callback(data)
    })
}

export {
  fetchDocumentRequests,
  searchUsers,
  getUser,
  createOrUpdateDocumentRequest,
  deleteDocumentRequest,
  fetchDocumentRequest,
  updateUser,
  markAsReadUserMessages,
  searchDocumentRequestTemplates,
}
